import { formatInTimeZone } from 'date-fns-tz'

import { Code, ICreateControllerLogRequest, Log, LogSource, LogStatus, MandatoryLogInformation } from '@/types/logs'
import { getMandatoryFieldsForLog } from './getMandatoryFieldsForLog'
import { formatMechanicalInformationRequestBody } from '@/modules/MechanicalInformation/helpers/formatMechanicalInformationRequestBody'
import { formatOfficialReportRequestBody } from '@/modules/OfficialReport/helpers/formatOfficialReportRequstBody'

import { IUserInfoResponse } from '@/types/user'
import { DEFAULT_CODING_PERIOD } from '../constant'

export const formatLogRequestBody = ({
    requestBody,
    codes,
    userInfo,
}: {
    requestBody: ICreateControllerLogRequest
    codes: Code[]
    userInfo?: IUserInfoResponse
}): Log => {
    const requiredFields = getMandatoryFieldsForLog(requestBody as unknown as Log)

    const {
        description = '',
        extraInfo = '',
        strategy = '',
        selectedCodeTypeReasonId,
        rtnTrips,
        report,
        mechanicalInfo,
        ...rest
    } = requestBody
    const selectedCode = codes.find((item) => item.code === requestBody.code)

    const log: Partial<Log> = {
        ...rest,
        codingPeriodInfo: DEFAULT_CODING_PERIOD,
        descriptionInfo: {
            description,
            extraInfo,
            strategy,
        },
        source: LogSource.Manual,
        timestamp: requestBody.timeStamp || formatInTimeZone(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        delayInMinutes: requestBody.delay ? +requestBody.delay : undefined,
        codeTypeReasonInfo: selectedCode?.reasons.find((item) => item.reasonId === selectedCodeTypeReasonId),
        rtnTrips: rtnTrips ? rtnTrips : [],
        eventLog: requestBody.eventLogId
            ? ({
                  id: requestBody.eventLogId,
              } as Log)
            : null,
    }

    const hasMissingData = requiredFields.some((field) => {
        if (field === MandatoryLogInformation.Description || field === MandatoryLogInformation.ExtraInfo) {
            return !log.descriptionInfo?.[field]
        }

        return !log[field]
    })

    log.status = hasMissingData ? LogStatus.Incomplete : LogStatus.Completed

    if (mechanicalInfo) {
        log.mechanicalInfo = formatMechanicalInformationRequestBody(mechanicalInfo, log as Log)
    }

    if (report) {
        log.report = formatOfficialReportRequestBody(report, userInfo, log as Log)
    }

    return log as Log
}
